// member/refer_requests/organizations_for_referral

import { baseApi } from './baseApi';

export const organizationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationsForReferral: builder.query({
      query: () => '/member/refer_requests/organizations_for_referral',
      providesTags: ['Organizations'],
    }),
    getCompanyProfile: builder.query({
      query: (id) => `/company_profiles/${id}`,
      providesTags: ['Company'],
    }),
    getOrganizationStrengthenQuestions: builder.query({
      query: ({ organizationId }) => ({
        url: `/member/strengthen_questions?organization_id=${organizationId}`,
        method: 'GET',
      }),
      providesTags: ['OrganizationStrengthenQuestions'],
    }),
    getOrganizationReferralFormPermissions: builder.query({
      query: ({ organizationId }) => ({
        url: `/member/referral_form_permissions?organization_id=${organizationId}`,
        method: 'GET',
      }),
      providesTags: ['OrganizationReferralFormPermissions'],
    }),
    getOrganizationPaymentPermissions: builder.query({
      query: ({ organizationId }) => ({
        url: `/member/payment_permissions?organization_id=${organizationId}`,
        method: 'GET',
      }),
      providesTags: ['OrganizationPaymentPermissions'],
    }),
  }),
});

export const {
  useGetOrganizationsForReferralQuery,
  useGetCompanyProfileQuery,
  useGetOrganizationStrengthenQuestionsQuery,
  useGetOrganizationReferralFormPermissionsQuery,
  useGetOrganizationPaymentPermissionsQuery,
} = organizationApi;
